import { render, staticRenderFns } from "./DesignStudioV3.vue?vue&type=template&id=560e2e7e"
import script from "./DesignStudioV3.vue?vue&type=script&lang=js"
export * from "./DesignStudioV3.vue?vue&type=script&lang=js"
import style0 from "./DesignStudioV3.vue?vue&type=style&index=0&id=560e2e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports